import * as $ from 'jquery';

export const DISPLAYED_PRODUCT_LIST_CHANGE = 'displayed-product-list-changed';

const reserverdElements = new Set();

(() => {
    let previousId = Math.random();
    $(document).ready(() => {
        document.addEventListener(DISPLAYED_PRODUCT_LIST_CHANGE, ({detail}) => {
            if (detail && previousId !== detail.id) {
                $('#' + detail.id).parents('.taxon-chunk[data-dl-on-view]').each((i, el) => {
                    $(el).data('dl-on-view').map((event) => {
                        window.dataLayer.push(event);
                    });
                });
                previousId = detail.id;
            }
        });
    });
})();

export function onLoad() {
    $('[data-dl-on-change]').each((i, el) => {
        if (!reserverdElements.has(el)) {
            $(el).on('change', (e) => {
                $(e.currentTarget).data('dl-on-change').map((event) => {
                    window.dataLayer.push(event);
                });
            });
            reserverdElements.add(el);
        }
    });
    $('[data-dl-on-click]').each((i, el) => {
        if (!reserverdElements.has(el)) {
            $(el).on('click', (e) => {
                $(e.currentTarget).data('dl-on-click').map((event) => {
                    window.dataLayer.push(event);
                });
            });
            reserverdElements.add(el);
        }
    });
    $('[data-dl-on-input-once]').each((i, el) => {
        if (!reserverdElements.has(el)) {
            (() => {
                let inputTriggered = false;
                $(el).on('input', (e) => {
                    if (!inputTriggered) {
                        $(e.currentTarget).data('dl-on-input-once').map((event) => {
                            window.dataLayer.push(event);
                        });
                        inputTriggered = true;
                    }
                });
            })();
            reserverdElements.add(el);
            if ($(el).find('input[type="text"]').toArray().map(input => input.value).join('').length) {
                $(el).data('dl-on-input-once').map((event) => {
                    window.dataLayer.push(event);
                });
            }
        }
    });
};
